<template>
  <ClientsWidget
    :title="$t('My clients')"
    :subtitle="$t('The companies that have added you to their talent pool')"
    :empty-text="$t('You\'re not part of any client talent pools')"
    :loading="loading"
    :sections="sections"
  >
    <template #row="{ item }">
      <WorkerClientRow :client="(item as FragmentType<typeof WorkerClientFragmentDoc>)" />
    </template>
  </ClientsWidget>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { graphql, type FragmentType } from '@/gql'
import { useTranslation } from '@/composables/translation'
import { ContactStatus, WorkerClientFragmentDoc } from '@/gql/graphql'
import ClientsWidget from '@/components/Dashboard/Widgets/Clients/ClientsWidget.vue'
import WorkerClientRow from '@/components/Dashboard/Widgets/Clients/WorkerClientRow.vue'

const { $t } = useTranslation()
const account = currentAccount.globalId

const { result, loading } = useQuery(
  graphql(`
    query WorkerClients($id: ID!) {
      worker(id: $id) {
        id
        clients {
          id
          status
          ...WorkerClient
        }
      }
    }
  `),
  computed(() => ({ id: account })),
  {
    clientId: 'publicApi',
    fetchPolicy: 'network-only',
  },
)

const clients = computed(() =>
  [
    ...(result.value?.worker?.clients?.filter(
      ({ status }) =>
        status !== ContactStatus.Applied &&
        status !== ContactStatus.Blocked &&
        status !== ContactStatus.Declined,
    ) ?? []),
  ].reverse(),
)

const appliedClients = computed(() => [
  ...(result.value?.worker?.clients?.filter(({ status }) => status === ContactStatus.Applied) ??
    []),
])

const sections = computed(() => [
  { items: clients.value },
  { label: $t('Applied to join:'), items: appliedClients.value },
])
</script>
